<template>
    <div class="collection-view">
        <div class="tabs-mask">
            <div
                v-for="(item,index) in tabs"
                :key="index"
                class="tab-item"
                :class="{'checked-tab': index===checkedTabIndex}"
                @click="checkTab(index)"
            >
                {{ langTransfer(item.text) }}
            </div>
        </div>
        <bscroll-view>
            <div class="main-content">
                <div class="list-wrap">
                    <div v-if="checkedTabIndex === 0" class="result-list">
                        <div v-for="(item,index) in list"
                             :key="collectionItemKey(item, index)"
                             class="magazine-item"
                             @click="detailDispatcher('magazineArticle', item, 'collection')"
                        >
                            <div class="hb-resource-cover lr-img-scale">
                                <img v-if="item.poster" :src="item.poster">
                            </div>
                            <p class="text1line">
                                {{ langTransfer(item.title) }}
                            </p>
                            <p v-if="issueLabel(item)" class="issue-line text1line">
                                {{ langTransfer(issueLabel(item)) }}
                            </p>
                        </div>
                    </div>
                    <div v-if="checkedTabIndex === 1" class="result-list">
                        <div v-for="(item,index) in list"
                             :key="index"
                             class="magazine-item"
                             @click="detailDispatcher('book',item,'collection')"
                        >
                            <div class="hb-resource-cover lr-img-scale">
                                <img v-if="item.poster" :src="item.poster">
                            </div>
                            <p class="text1line">
                                {{ langTransfer(item.title) }}
                            </p>
                        </div>
                    </div>
                    <div v-if="checkedTabIndex === 2" class="result-list">
                        <div v-for="(item,index) in list"
                             :key="index"
                             class="magazine-item audio-item"
                             @click="detailDispatcher('audio',item)"
                        >
                            <div class="hb-resource-cover lr-img-scale">
                                <img :src="item.poster">
                                <img class="play-icon" src="@/assets/img/play.png">
                            </div>
                            <p class="text2line">
                                {{ langTransfer(item.title) }}
                            </p>
                        </div>
                    </div>
                    <div v-if="checkedTabIndex === 3" class="result-list">
                        <div v-for="(item,index) in list"
                             :key="index"
                             class="magazine-item video-item"
                             @click="detailDispatcher('video',item)"
                        >
                            <div class="hb-resource-cover lr-img-scale">
                                <img :src="item.poster">
                                <img class="play-icon" src="@/assets/img/play.png">
                            </div>
                            <p class="text2line">
                                {{ langTransfer(item.title) }}
                            </p>
                        </div>
                    </div>
                    <div v-if="checkedTabIndex === 4" class="result-list">
                        <div v-for="(item,index) in list"
                             :key="index"
                             class="magazine-item"
                             @click="detailDispatcher('knowledgeBook',item,'collection')"
                        >
                            <div class="hb-resource-cover lr-img-scale">
                                <img v-if="item.poster" :src="item.poster">
                            </div>
                            <p class="text1line">
                                {{ langTransfer(item.title) }}
                            </p>
                        </div>
                    </div>
                   <div v-if="checkedTabIndex === 5" class="result-list">
                        <div v-for="(item,index) in list"
                             :key="index"
                             class="magazine-item"
                             @click="detailDispatcher('assemblyBook', item,'collection')"
                        >
                            <div class="hb-resource-cover lr-img-scale">
                                <img v-if="item.poster" :src="item.poster">
                            </div>
                            <p class="text1line">
                                {{ langTransfer(item.title) }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="action-warning-wrap">
                    <button v-show="list.length > 0 && !getAll"
                            class="common-read-more lr-img-scale"
                            @click="loadMore"
                    >
                        {{ langTransfer('加载更多') }}
                    </button>
                    <div v-show="list.length > 0 && getAll"
                         class="has-no-more"
                    >
                        {{ langTransfer('- 没有更多了 -') }}
                    </div>
                </div>
            </div>
        </bscroll-view>
    </div>
</template>

<script>
    import BscrollView from '@/components/bscrollView'
    import { collectList } from '@/api/hb'

    export default {
        name: 'Collection',
        components: {
            BscrollView
        },
        data () {
            return {
                checkedTabIndex: 0,
                tabs: [
                    {
                        text: '期刊',
                        type: 7
                    },
                    {
                        text: '图书',
                        type: 8
                    },
                    {
                        text: '音频',
                        type: 10
                    },
                    {
                        text: '视频',
                        type: 11
                    },
                    {
                        text: '知识书',
                        type: 12
                    },
                    {
                        text: '汇编书',
                        type: 16
                    }
                ],
                list: [],
                getAll: false,
                endScreen: false
            }
        },
        computed: {
            user_unique_code () {
                return this.$store.state.user_unique_code
            },
            webInfo () {
                return this.$store.state.webInfo
            }
        },
        watch: {
            webInfo (newVal) {
                if (newVal.service_code) {
                    this.getCollectionList()
                }
            }
        },
        created () {
        },
        methods: {
            collectionItemKey (item, index) {
                return [item.id, item.year || item.Year, item.issue || item.Issue, index].join('-')
            },
            issueLabel (item) {
                const year = item.year || item.Year
                const issue = item.issue || item.Issue
                if (year == null || year === '' || issue == null || issue === '') {
                    return ''
                }
                return `${year}年${(`0${issue}`).substr(-2)}期`
            },
            konwledgebookClickHandler (item) {
                const { href } = this.$router.resolve({
                    path: '/occupationBookDetail',
                    query: {
                        id: item.id
                    }
                })
                window.open(href, '_blank')
            },
            checkTab (index) {
                if (this.checkedTabIndex === index) {
                    return
                }
                this.checkedTabIndex = index
                this.getAll = false
                this.list = []
                this.getCollectionList()
            },
            loadMore () {
                const newPage = Math.ceil(this.list.length / 10) + 1
                this.getCollectionList(newPage)
            },
            async getCollectionList (page = 1) {
                try {
                    const {
                        tabs, checkedTabIndex
                    } = this
                    const { type } = tabs[checkedTabIndex]
                    const data = await collectList({
                        type,
                        service_code: this.webInfo.service_code,
                        page,
                        pageSize: 10,
                        user_unique_code: this.user_unique_code
                    })
                    data.forEach((e) => {
                        e.name = e.name || e.title
                    })
                    if (page !== 1) {
                        this.list = this.list.concat(data)
                        return
                    }
                    if (data.length < 10) {
                        this.getAll = true
                    }
                    this.list = data
                } catch (err) {
                    if (err.code === '-1') {
                        this.getAll = true
                    }
                    console.log(err)
                }
            }
        },
        beforeRouteEnter (to, from, next) {
            next((vm) => {
                const { service_code } = vm.webInfo
                if (service_code) {
                    vm.getCollectionList()
                }
            })
        }
    }
</script>

<style scoped lang="less">
    .collection-view {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }

    .tabs-mask {
        width: 100%;
        box-sizing: border-box;
        padding: 30px 48px 20px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
    }

    .tab-item {
        padding: 5px 10px;
        font-size: 15px;
        font-family: AlibabaPuHuiTiM;
        color: #909399;
        line-height: 24px;
        margin-right: 30px;
        cursor: pointer;
        user-select: none;

        &:last-child {
            margin-right: 0;
        }
    }

    .checked-tab {
        color: #303133;
        box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
    }

    .main-content {
        width: 100%;
    }

    .action-warning-wrap {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 40px;

        .has-no-more {
            font-size: 14px;
            font-family: AlibabaPuHuiTiM;
            color: rgb(170, 169, 169);
            line-height: 40px;
            user-select: none;
        }
    }

    .list-wrap {
        width: 100%;
        padding-bottom: 20px;
    }

    .result-list {
        width: 100%;
        box-sizing: border-box;
        padding: 0 48px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;
    }

    .magazine-item {
        width: 150px;
        margin-right: 24px;
        margin-bottom: 20px;

        .hb-resource-cover {
            width: 150px;
            height: 200px;
            border-radius: 4px;
        }

        p {
            width: 100%;
            font-size: 15px;
            font-family: AlibabaPuHuiTiM;
            color: #606266;
            line-height: 24px;
            margin-top: 10px;
        }

        .issue-line {
            font-size: 13px;
            color: #909399;
            line-height: 20px;
            margin-top: 2px;
        }
    }

    .audio-item {

        .hb-resource-cover {
            width: 150px;
            height: 150px;
            border-radius: 8px;
        }
    }

    .video-item {
        width: 237px;

        .hb-resource-cover {
            width: 237px;
            height: 134px;
            border-radius: 8px;
        }
    }

    .audio-item,.video-item {

        .hb-resource-cover {
            position: relative;
        }

        &:hover {

            .play-icon {
                opacity: 1;
            }
        }

        .play-icon {
            width: 32px;
            height: 32px;
            position: absolute;
            right: 10px;
            bottom: 10px;
            opacity: 0;
            transition: .3s;
        }
    }
</style>
